module.exports = __webpack_public_path__ + "img/pwa-inf.2da23921.jpg";